// extracted by mini-css-extract-plugin
export default {"item-list":"MainsMobile_item-list__-mtgL","item":"MainsMobile_item__8jF8A","main-section":"MainsMobile_main-section__xjE2c","mains-subtitle":"MainsMobile_mains-subtitle__yBMvc"};